import Const from '../const';

const setStepLoading = (stepLoading) => ({
  type: Const.wizard.stepLoading,
  stepLoading
});

const setSignupEventSent = () => ({
  type: Const.wizard.signupEventSent
});

export const stepLoadingAction = () => (dispatch) => {
  dispatch(setStepLoading(true));
};

export const stepLoadedAction = () => (dispatch) => {
  dispatch(setStepLoading(false));
};

export const signupEventSentAction = () => (dispatch) => {
  dispatch(setSignupEventSent());
};
